<template>
    <div id="container" @keydown.enter="submitForm">
        <p>{{differentContent.titleCon}}</p>
        <div class="skin-content">
            <el-row style="margin-bottom: 10px" :gutter="10">
                <el-col :span="12" :offset="6">
                    <el-input v-model="loginForm.phone" type="text" placeholder="手机号/用户名"></el-input>
                </el-col>
                <el-col :span="3">
                    <p @click="openRegisterWin" style="font-size:12px">注册用户</p>
                </el-col>
            </el-row>
            <el-row style="margin-bottom: 10px" :gutter="10">
                <el-col :span="12" :offset="6">
                    <el-input v-model="loginForm.password" type="password" placeholder="密码"></el-input>
                </el-col>
                <el-col :span="3">
                    <p @click="openResetPassWin" style="font-size:12px">忘记密码</p>
                </el-col>
            </el-row>
            <el-row style="margin-bottom: 10px" :gutter="10">
                <el-col :span="4" :offset="6">
                    <el-checkbox v-model="savePassword" style="color: #ccc;">记住密码</el-checkbox>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="12" :offset="6">
                    <el-button type="primary" style="padding:0" class="skin-btn" @click="submitForm">登录</el-button>
                </el-col>
            </el-row>
            <div class="QR-code-wrapper">
                <div class="QR-code">
                    <img class="QR-img" src="../assets/skinreader_QRcode.png" alt="">
                </div>
                <div class="title">扫码下载医生手机客户端</div>
            </div>
        </div>
    </div>
</template>
<script>
  import getControllers from '../gql/getController.gql'
  import api from '../api';
  import axios from 'axios';
  import {AxiosRequestConfig} from 'axios';
  import gql from 'graphql-tag';
  import csrftoken from '../getToken';
  // import { JSEncrypt } from 'jsencrypt';
  import Util from "../utils/utils.js";

  const differentContent = {};
  if (process.env.VUE_APP_SHOW_INTEL === 'yes') {
    differentContent.titleCon = '问鼎皮肤智慧云';
  } else {
    // differentContent.titleCon = '多模态皮肤影像PACS软件';
    // differentContent.titleCon = '问鼎皮肤智能诊断云平台';
    differentContent.titleCon = '问鼎皮肤智慧云';
  }
  
  export default {
    name: 'LoginPanel',
    apollo: {},
    data() {
      return {
        differentContent,
        dialogFormVisible: false,
        loginForm: {
          phone: '',
          password: '',
        },
        rules: {
          phone: [
            {required: true, message: '请输入手机号码', trigger: 'blur'},
            {min: 11, max: 11, message: '请输入长度为11位的中国大陆手机号', trigger: 'blur'},
          ],
          password: [
            {required: true, message: '请输入密码', trigger: 'blur'},
            {min: 6, max: 15, message: '长度在 3 到 15 个字符', trigger: 'blur'},
          ],
        },
        savePassword: false,
      };
    },
    mounted() {
      // 取本地账号密码
      if (window.localStorage) {
        if (localStorage.sv_ps) {
          const data = JSON.parse(localStorage.getItem("sv_ps"));
          this.loginForm.phone = data.phone;
          this.loginForm.password = data.password;
          this.savePassword = true;
        } else if (localStorage.sv_ph) {
          const data = JSON.parse(localStorage.getItem("sv_ph"));
          this.loginForm.phone = data.phone;
        }
      }
    },
    methods: {
      // 用户注册
      openRegisterWin() {
        // 触发父组件的事件
        this.$emit('openRegisterWin');
      },
      // 重置密码
      openResetPassWin() {
        this.$emit('openResetPassWin');
      },
      //  RSA加密
      // encryptedData(data) {
      //   // 新建JSEncrypt对象
      //   let encryptor = new JSEncrypt();
      //   // 设置公钥
      //   // let publicKey = "-----BEGIN PUBLIC KEY-----\nMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDayjSIymyR8DuQRnoMM6YYI962MnAV97bnWhk6Me9gCtZMjDRFpV7G+rQ+e3xn6i/LgrVhAu1sEJtMREci0N9DSg0vtfgO5KKXsaRTOpMfogwlDlCMeAMCQGsJ3n55jmb0gIdXW0iQz4OL6N78RinNIB2hTk7EbPV6dZul35jfYwIDAQAB\n-----END PUBLIC KEY-----"
      //   let publicKey = '-----BEGIN PUBLIC KEY-----\nMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAgSajWypYc27WI8y5aZZ9BnYtUjKmaiLcSa3GTnpxIhFBJ3t4qMsRUw6G0C8qoRGQ31ASr4ghvQQZuRl37WFuJS0iSsIE9Tz1K4/Oof3jsVJ6dhzEajM8gy2ZWE4V5fAKmn6tTgIRb+SRXDpbbxYSb3c175vwC95WCvG3u6iZ1lvUaTpFYg/zHWMjs3AF+Uxy6V5QNN3f8vns98pRYAKzqLNnxnAIFsiX+Pfpwcgbd5D0q3rYimco0zce35DzscFamlLE6W2AH8A6TJ4WPzLVD7AgyXLyESw0aXrcPxqUvxLeTVgA3P6YbYLwJi9+QfDT6Ql/UWEN1LH5KSk+GDv8ywIDAQAB\n-----END PUBLIC KEY-----'
      //   encryptor.setPublicKey(publicKey);
      //   // 加密数据
      //   let code = encryptor.encrypt(data);
      //   console.log("In LoginPanel, password after RSA Enc:",code);

      //   return code
      // },

      // 获取账户信息，包括套餐类型，日期，当前存储空间使用情况等
      async getAccountInfo(leader_id){
        // let doctor_id = this.$store.state.doctorId
        // console.log("In getAccountInfo, doctor_id:",doctor_id)
        if (leader_id) {
          const res = await this.$apollo.query({
            query: gql`
              query($doctor_id: Int) {
                accountInfo(doctor_id: $doctor_id){
                    id
                    doctor_id
                    user_type
                    account_type
                    trial_start_date
                    trial_end_date
                    trial_months
                    vip_start_date
                    vip_expire_date
                    status 
                    message
                    space_used
                    space_allocated
                    operation_time
                    head_title
                    constrain_special_desease
                }
            }`,
            variables: {
              doctor_id: leader_id
            },  
            fetchPolicy: "no-cache"
          });
          let accountInfo = res.data.accountInfo;
          // console.log("In getAccountInfo, accountInfo:", accountInfo);
          return accountInfo        
          // 即使数据库无记录，返回数据为 {id: null, doctor_id: null, user_type: null, account_type: null, trial_start_date: null...}
          // if(accountInfo!==null && accountInfo.doctor_id!==null){
          //   this.$store.commit("setAccountInfo", JSON.stringify(accountInfo));
          //   console.log("In getAccountInfo, test get accountInfo from store.state:",JSON.parse(this.$store.state.accountInfo));
          // }else{
          //   this.$store.commit("setAccountInfo", "");
          // }
        }
      },

      // 登录事件
      async submitForm() {
        try {
          let namephone = this.loginForm.phone;
          let password = this.loginForm.password;

          if (namephone === '') {
            this.$message.error('用户名不能为空');
            return;
          }
          if (password === '') {
            this.$message.error('密码不能为空');
            return;
          }
          let from = "PC";
          // Encrypt with rsa pub key
          password = Util.rsaEncryptData(password);
          let datas = await this.$apollo.mutate({
            // Query
            mutation: gql`mutation{
          doctorLogin(namephone:"${namephone}",password:"${password}",from:"PC")
          }`,
          })
          if (datas.data.doctorLogin === null) {
            // 保存账号密码
            if (this.savePassword) {
              localStorage.setItem("sv_ps", JSON.stringify(this.loginForm));
            } else {
              const ph = this.loginForm.phone;
              const data = {
                phone: ph,
              };
              localStorage.setItem("sv_ph", JSON.stringify(data));
              localStorage.removeItem('sv_ps');
            }
            sessionStorage.setItem('username', this.loginForm.phone);
            if (window.eventSrc) {
              window.eventSrc.close();
            }
            this.loginForm.phone = '';
            this.loginForm.password = '';
            this.$message({
              message: '登录成功',
              type: 'success'
            });

            let res = await this.$apollo.query({
              query: gql`{
                      me{
                          id,
                          realname,
                          leader_id,
                          agent_config,
                          image_modality{
                            id
                            modality_name
                          }
                          advanced_function{
                            id
                            module_name
                          }
                      }
                  }`,
              fetchPolicy: 'no-cache',
            });

            window.sessionStorage.setItem('me_id', res.data.me.id);
            window.localStorage.removeItem('system_set');
            const agentConfig = res.data.me.agent_config;
            if (agentConfig) {
              window.localStorage.setItem('system_set', agentConfig);
            }
            let realname = res.data.me.realname;
            this.$store.commit("setMe", realname);
            localStorage.setItem("me", realname);
            this.$store.commit('setdoctorDitail',{id:res.data.me.id,realname:res.data.me.realname})
            // 开启loading
            const loginLoading = this.$loading({
              lock: true,
              background: 'rgba(255, 255, 255, 0.1)'
            });
            this.$store.commit('openLoading', loginLoading);
            this.$store.commit('controller/sethasLogin', true);
            
            // 获取账户信息/存储空间使用情况
            let leader_id = res.data.me.leader_id;
            let accountInfo = await this.getAccountInfo(leader_id);
            this.$store.commit("setAccountInfo", accountInfo ? accountInfo : {});
            // let storageRateMsg = Util.getStorageRateMsg(accountInfo);
            // if(!storageRateMsg){
            //   this.$message.error(storageRateMsg);
            // }
            if(accountInfo.space_used && accountInfo.space_allocated){
              let usageRate = (accountInfo.space_used / accountInfo.space_allocated) * 100;
              if(usageRate >= 90){
                this.$message.error("存储空间即将用尽，请尽快联系管理员升级扩容！点击\"我的账户\"查看详情。");
              }else if(usageRate >= 80){
                this.$message.error("存储空间即将不足，建议尽快升级扩容！点击\"我的账户\"查看详情。");
              }
            }
            // 登录成功后根据权限跳转
            let newRes = res.data.me;
            // console.log(newRes.image_modality);
            let hasHairTitle = false;
            if(newRes.advanced_function){
              for(let i =0;i<newRes.advanced_function.length;i++) {
                if(newRes.advanced_function[i].module_name ==='美容/光疗'){
                  hasHairTitle = true;
                  break;
                }
              }
            }
            
            if(newRes.image_modality && newRes.image_modality.length>0){
              /*this.$router.push({path: '/home'});*/
              this.$router.push({path: "/home/Intell"});
            }else if (hasHairTitle) {
              this.$router.push({path: '/home/hairdressing'})
            }else{
              this.$router.push({ path: '/home/Patients' })
            }
            
          /*  this.$router.push({path: '/home'});*/

          }
        } catch (e) {
          
          let message = e.message.split(":")[1];
          //this.$message.error(message);
          //this.$message.error(e);
          //console.log(message)
          if (e.message.split(":")[1] === " Failed to fetch") {
          return;
        }
        //this.$message.error(`${message}`);
        }
      },
    },
  };
</script>
<style scoped lang="less">
    .QR-code-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        padding-right: 20px;
        padding-bottom: 20px;
        
        .QR-code {
            width: 100px;
            height: 100px;
            
            .QR-img {
                width: 100%;
                height: 100%;
            }
        }
        
        .title {
            color: #fff;
            margin-top: 10px;
            font-size: 12px;
            font-weight: lighter;
        }
    }
</style>

